import { render, staticRenderFns } from "./PlotEditPage.vue?vue&type=template&id=06ad005e"
import script from "./PlotEditPage.vue?vue&type=script&lang=ts"
export * from "./PlotEditPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06ad005e')) {
      api.createRecord('06ad005e', component.options)
    } else {
      api.reload('06ad005e', component.options)
    }
    module.hot.accept("./PlotEditPage.vue?vue&type=template&id=06ad005e", function () {
      api.rerender('06ad005e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/PlotEditPage.vue"
export default component.exports